<template>
<div class="chapter">
<div class="inner_page">
<section>
<h2><span class="h2-inner">Chapter 5</span></h2>
<p class="firstInSection">Jack’s first port of call was the cells beneath Manchester Crown Court. He rehearsed his patter whilst waiting for the prison officers to open up. Be confident and take control, he told himself.</p>
<p>His sixteen-year-old client, Billy Birt, was sitting on a chair at a desk, wearing his school uniform. Someone must have told him it would help his chances of bail. His ginger hair was neatly combed to one side. There was something comical about it. Billy had the appearance of a model pupil, sitting in a classroom during a lesson.</p>
<p>‘And who the fuck are you?’</p>
<p>‘I’m your barrister, Jack Kowalski.’</p>
<p>‘You what?’</p>
<p>‘Jack Kowalski.’</p>
<p>‘You look a bit young to me. Still in short fockin’ trousers. I don’t want no muppet. I told Ken ‒ definitely no muppets.’ Billy was up and walking around the visiting room, becoming increasingly agitated. ‘You know who my dad is? You know my family? We fockin’ run Wythenshawe. D’ya get me?’</p>
<p>Billy was just a vicious little burglar. As was his dad. Those that could honestly claim to run Billy’s neighbourhood shot people for fun.</p>
<p>‘I do know, Billy. That’s why this is the only hearing I’m doing today. Ken has demanded an exclusive service. That’s what the Birts get. Total focus on getting you out.’</p>
<p>Billy began to calm down, a little flattered. Eventually, he sat down. ‘Alright, fella,’ he said conspiratorially. ‘Tell me how you’re gonna get me bail?’</p>
<p>Jack took a seat and undid the ribbon on the brief. ‘The judge’s main concern will be the risk of reoffending, particularly at night. I’m going to suggest an electronically monitored curfew.’</p>
<p>‘What? A tag?’</p>
<p>‘Yes. I know it’s not ideal, but it’s better than being banged up.’</p>
<p>Billy nodded. ‘You know we got a High Court judge?’</p>
<p>‘I believe so,’ Jack replied in an attempt at indifference.</p>
<p>‘What’s he like? Miserable git, I’ve heard.’</p>
<p>‘Don’t worry, Billy. I can handle him.’ He gave his client a confident wink. ‘Better go. We’re up in five. I’ll see you after – hopefully on the outside.’</p>
<p>Billy watched his barrister’s trembling hands retie the pink ribbon. He was not entirely convinced.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter8.vue?323d29c4